import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { PublicSvgIcon } from "~/components/public_svg_icon";

export function PayoutsPausedBanner() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Stack
      spacing={isOpen ? 2 : 0}
      sx={{
        py: 2.5,
        px: { xs: 2, sm: 3, lg: 6 },
        bgcolor: "error.50",
        borderLeft: 4,
        borderColor: "error.main",
        borderRadius: 3,
      }}
      data-testid="payouts-paused-banner"
    >
      <Box
        component="button"
        type="button"
        aria-expanded={isOpen}
        aria-controls="payouts_paused-content"
        onClick={() => setIsOpen((open) => !open)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          width: "100%",
          p: 0,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          textAlign: "left",
          font: "inherit",
          color: "text.primary",
        }}
        data-testid="payouts-paused-toggle-button"
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <PublicSvgIcon name="info_error" size={24} />
          <Typography variant="h6" component="span">
            Payouts on hold due to outstanding refund costs
          </Typography>
        </Stack>
        <PublicSvgIcon
          name="keyboard_arrow_up"
          inheritColor
          sx={{
            display: "flex",
            transform: isOpen ? "none" : "rotate(180deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </Box>
      <Collapse in={isOpen} id="payouts_paused-content">
        <Typography variant="body2" color="text.secondary">
          When a refund is initiated but your account balance is insufficient to
          cover the refund, Trustap will advance the refund to the buyer and log
          the amount owed as outstanding refund costs. Payouts remain on hold
          until all outstanding refund costs are cleared.
          <br />
          Once your account balance increases sufficiently through new
          successful transaction, outstanding refund costs are automatically
          cleared on an hourly basis. Your account balance must be sufficient to
          cover a refund in full to clear it. Partial clearing is not supported.
        </Typography>
      </Collapse>
    </Stack>
  );
}
